import Vue from 'vue'
import App from '@/App'
import router from '@/router' // api: https://github.com/vuejs/vue-router
import store from '@/store' // api: https://github.com/vuejs/vuex
import '@/icons' // api: http://www.iconfont.cn/
import '@/assets/scss/index.scss'
import '@/assets/global.scss'
import VueLazyload from 'vue-lazyload'
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.use(VueLazyload, {
  　　 // 设置默认显示的图片
  loading: require('./assets/img/loading.gif'),
  error: require('./assets/img/error.jpg'),
})


Vue.config.productionTip = false

import util from './util'
import './permission'
import *  as  allAPI from './util/api';
require('promise.prototype.finally').shim();
Vue.prototype.$http = allAPI;
Vue.prototype.$util = util


 

import * as filters from './filters/index.js'

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

function initVue() {
  return new Vue({
    store,
    router,
    render: h => h(App)
  }).$mount('#app')
}

let vueInst = initVue();

if (window && !window.vue) {
  window.vue = vueInst;
}
export default vue;



// WEBPACK FOOTER //
// ./src/main.js